<template>
  <div class="card" v-if="devis">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'ajoutDevis.problemOccurred'"
                           @close="error = $event"/>
      <p class="modal-title has-text-centered mgb-50px">
        {{$t('ajoutDevis.toOrderTitle', { code: devis.code })}}
      </p>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('ajoutDevis.actions.revert')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="valider()" >
            {{ $t('ajoutDevis.actions.toOrderConfirme')}}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { generationCommandes } from '@/api/commande/index';
import * as types from '@/store/modules/commande-mutation-type';
import validationPassageCommande from '@/services/devisCommandes/validation/validationPassageCommande';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import addReferenceEcheancierToAllLignes
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToAllLignes';

const Commandes = createNamespacedHelpers('commande');

export default {
  name: 'confirmation-commande',
  props: {
    devis: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      error: false,
    };
  },
  computed: {
  },
  methods: {
    ...Commandes.mapMutations({
      setCommande: types.SET_COMMANDE,
    }),
    async valider() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const commandes = (await generationCommandes({
          id: this.devis.id,
        })).data.result;
        if (commandes == null || commandes.length === 0) {
          const e = new Error();
          e.response = {
            data: {
              error: {
                validationErrors: [{
                  message: 'NOT_ORDER',
                }],
              },
            },
          };
          throw e;
        }

        const commande = commandes[0];
        commande.lignesCommande.forEach((lignes) => {
          lignes.affectation = [];
          lignes.selected = false;
        });
        if (commande.echeanciers.length === 0) addReferenceEcheancierToAllLignes(commande);
        this.setCommande(commande);
        await this.$router.push({ name: 'm.bodac.commandes-ajout' });
        return loadingComponent.close();
      } catch (e) {
        if (e.response) {
          this.messages = [];
          validationPassageCommande(e.response, this.messages, this.$i18n);
          this.error = true;
          return loadingComponent.close();
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>
